export const Observation = {
  department: '',
  departmentOther: '',
  employeeId: '',
  employeeName: '',
  otherEmployeeName: '',
  otherEmployeeNumber: '',
  date: '',
  areaId: '',
  areaObserve: '',
  areaOwnerId: '',
  areaOwnerName: '',
  pic: '',
  dic: '',
  categoryObserve: '',
  categoryObserveOther: '',
  relatedProduct: '',
  relatedProductOther: '',
  foreignMatter: '',
  foreignMatterOther: '',
  foreignMatterLocation: '',
  relatedQuantity: '',
  relatedQuantityOther: '',
  packageObserve: '',
  packageObserveOther: '',
  relatedIsotank: '',
  relatedIBC: '',
  relatedContainer: '',
  relatedJumboBag: '',
  relatedPaperBag: '',
  relatedDrum: '',
  relatedLabel: '',
  relatedEmployee: '',
  relatedEmployeeOther: '',
  relatedWork: '',
  relatedWorkOther: '',
  evidence: '',
  remark: '',
  isReported: false,
  categoryLevel: '',
  issueReportedTo: ''
}